import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=365cc0d3&"
import script from "./CommentForm.vue?vue&type=script&lang=js&"
export * from "./CommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365cc0d3')) {
      api.createRecord('365cc0d3', component.options)
    } else {
      api.reload('365cc0d3', component.options)
    }
    module.hot.accept("./CommentForm.vue?vue&type=template&id=365cc0d3&", function () {
      api.rerender('365cc0d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/comments/CommentForm.vue"
export default component.exports